import { useMemo } from "react";
import { Brand } from "../../../types/brand";
import { getBrandsWithoutMain, getDefaultCompetitor, resolveCompetitor } from "../utils/competitor";

interface UseSelectedBrandsParams {
  brands: Brand[] | null;
  mainBrandId: number | null;
  bestCompetitor: Brand | null;
  selectedCompetitorBrand: Brand | null;
  selectedBrand: Brand | null;
}

interface UseSelectedBrandsResult {
  resolvedCompetitor: Brand | null;
  selectedBrands: Brand[];
  selectedBrandIds: number[];
}

export const useSelectedBrands = ({
  brands,
  mainBrandId,
  bestCompetitor,
  selectedCompetitorBrand,
  selectedBrand,
}: UseSelectedBrandsParams): UseSelectedBrandsResult => {
  return useMemo(() => {
    const brandsWithoutMain = getBrandsWithoutMain(brands, mainBrandId);
    const defaultCompetitor = getDefaultCompetitor({ mainBrandId, bestCompetitor, brandsWithoutMain });
    const resolvedCompetitor = resolveCompetitor({
      mainBrandId,
      brandsWithoutMain,
      selectedCompetitorBrand,
      defaultCompetitor,
    }).resolved;

    const selectedBrands: Brand[] = [];
    if (selectedBrand) {
      selectedBrands.push(selectedBrand);
      if (resolvedCompetitor && resolvedCompetitor.id !== selectedBrand.id) {
        selectedBrands.push(resolvedCompetitor);
      }
    }

    return {
      resolvedCompetitor,
      selectedBrands,
      selectedBrandIds: selectedBrands.map((b) => b.id),
    };
  }, [bestCompetitor, brands, mainBrandId, selectedBrand, selectedCompetitorBrand]);
};
